import { Link as LinkIcon, Plus, Trash2, X } from 'lucide-react';
import { useState } from 'react';
import { C, F, JCFG, PC, PILLAR_COLORS, SC, diasRest, fmtDt, todayStr } from '../dashboard/_shared';
import "./style.scss";

function AcaoModal({ acao, prefilled, onSave, onClose, valoresAtuais = {} }) {
  function getValorUltimoMes(etapa, _tipo) {
    return valoresAtuais[etapa] ?? 0;
  }
  const empty = {
    id: Date.now().toString(),
    titulo: "",
    desc: "",
    etapa: "NPS Geral",
    tipo: "nps",
    v_atual: valoresAtuais["NPS Geral"] ?? 0,
    v_baseline: valoresAtuais["NPS Geral"] ?? 0,
    v_meta: "",
    resp: "",
    prazo: "",
    prio: "alta",
    status: "em_andamento",
    check: [],
    hist: [],
    med: [],
    origem: "Manual",
    links: [],
    drivers: [],
  };
  const initial = acao
    ? {
        ...acao,
        links: acao.links || [],
        drivers: acao.drivers || [],
        hist: acao.hist || [],
        v_baseline: acao.v_baseline ?? acao.v_atual,
      }
    : prefilled
      ? (() => {
          const merged = { ...empty, ...prefilled };
          const valor = getValorUltimoMes(merged.etapa, merged.tipo);
          return { ...merged, v_atual: valor, v_baseline: valor };
        })()
      : empty;
  const [f, setF] = useState(initial);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [newTask, setNewTask] = useState({ t: "", inicio: "", fim: "" });
  const [newLink, setNewLink] = useState({ label: "", url: "" });
  const valid = f.titulo && f.resp && f.prazo && f.v_meta !== "";

  const lbl = (t, required = false) => (
    <div className="compAcaoModal__label">
      {t}
      {required && <span style={{ color: "#e53e3e", marginLeft: 2 }}>*</span>}
    </div>
  );

  function addTask() {
    if (!newTask.t.trim()) return;
    setF((p) => ({
      ...p,
      check: [
        ...p.check,
        {
          i: Date.now(),
          t: newTask.t.trim(),
          f: false,
          inicio: newTask.inicio || null,
          fim: newTask.fim || null,
          concluido: null,
        },
      ],
    }));
    setNewTask({ t: "", inicio: "", fim: "" });
  }
  function addLink() {
    if (!newLink.url.trim()) return;
    const url = newLink.url.trim();
    const label =
      newLink.label.trim() || url.replace(/^https?:\/\//, "").slice(0, 40);
    setF((p) => ({
      ...p,
      links: [...(p.links || []), { id: Date.now(), label, url }],
    }));
    setNewLink({ label: "", url: "" });
  }
  function removeLink(id) {
    setF((p) => ({ ...p, links: (p.links || []).filter((l) => l.id !== id) }));
  }
  return (
    <div className="compAcaoModal__overlay">
      <div className="compAcaoModal__panel">
        <div className="compAcaoModal__header">
          <h3 className="compAcaoModal__title">
            {acao ? "Editar ação" : "Nova ação"}
          </h3>
          <button
            onClick={onClose}
            className="compAcaoModal__closeBtn"
          >
            <X size={20} />
          </button>
        </div>
        <div className="compAcaoModal__body">
          <div>
            {lbl("Título", true)}
            <input
              value={f.titulo}
              onChange={(e) => set("titulo", e.target.value)}
              className="compAcaoModal__input"
            />
          </div>
          <div>
            {lbl("Descrição")}
            <textarea
              value={f.desc}
              onChange={(e) => set("desc", e.target.value)}
              rows={2}
              className="compAcaoModal__input compAcaoModal__input--textarea"
            />
          </div>
          <div className="compAcaoModal__grid">
            <div className="compAcaoModal__gridFull">
              {lbl("Etapa / Indicador")}
              <select
                value={`${f.etapa}|${f.tipo}`}
                onChange={(e) => {
                  const [etapa, tipo] = e.target.value.split("|");
                  const novoAtual = getValorUltimoMes(etapa, tipo);
                  setF((p) => ({
                    ...p,
                    etapa,
                    tipo,
                    v_atual: novoAtual,
                    v_baseline: acao ? p.v_baseline : novoAtual,
                  }));
                }}
                className="compAcaoModal__input"
              >
                <option value="NPS Geral|nps">NPS Geral</option>
                <option value="CSAT Geral|csat">CSAT Geral</option>
                <option value="CES Geral|ces">CES Geral</option>
                <option disabled>──────── Etapas da Jornada ────────</option>
                {Object.entries(JCFG).map(([etapa, cfg]) => (
                  <option key={etapa} value={`${etapa}|${cfg.tipo}`}>
                    {etapa} ({cfg.label})
                  </option>
                ))}
              </select>
            </div>
            <div>
              {lbl(`Valor atual${f.etapa === "NPS Geral" ? "" : " (%)"}`)}
              <input
                type="number"
                min={-100}
                max={100}
                value={f.v_atual}
                onChange={(e) => {
                  const v = Number(e.target.value);
                  set("v_atual", Math.min(100, Math.max(-100, v)));
                }}
                className="compAcaoModal__input"
              />
              <div className="compAcaoModal__hint">
                {acao
                  ? `Baseline ao criar: ${f.v_baseline}${f.etapa === "NPS Geral" ? "" : "%"}`
                  : "Pré-preenchido com resultado de Mar/26"}
              </div>
            </div>
            <div>
              {lbl(`Meta do plano de ação${f.etapa === "NPS Geral" ? "" : " (%)"}`, true)}
              <input
                type="number"
                value={f.v_meta}
                onChange={(e) => set("v_meta", e.target.value)}
                className="compAcaoModal__input"
              />
            </div>
            <div>
              {lbl("Responsável", true)}
              <input
                value={f.resp}
                onChange={(e) => set("resp", e.target.value)}
                className="compAcaoModal__input"
              />
            </div>
            <div>
              {lbl("Prazo", true)}
              <input
                type="date"
                value={f.prazo}
                onChange={(e) => set("prazo", e.target.value)}
                className="compAcaoModal__input"
              />
            </div>
            <div>
              {lbl("Prioridade")}
              <select
                value={f.prio}
                onChange={(e) => set("prio", e.target.value)}
                className="compAcaoModal__input"
              >
                <option value="alta">Alta</option>
                <option value="media">Média</option>
                <option value="baixa">Baixa</option>
              </select>
            </div>
            <div>
              {lbl("Status")}
              <select
                value={f.status}
                onChange={(e) => set("status", e.target.value)}
                className="compAcaoModal__input"
              >
                <option value="pendente">Pendente</option>
                <option value="em_andamento">Em andamento</option>
                <option value="concluido">Concluído</option>
                <option value="cancelado">Cancelado</option>
              </select>
            </div>
          </div>
          <div>
            {lbl("Tarefas")}
            {f.check.map((c) => (
              <div
                key={c.i}
                className="compAcaoModal__taskItem"
              >
                <span className="compAcaoModal__taskText">{c.t}</span>
                <span className="compAcaoModal__taskDates">
                  {c.inicio ? fmtDt(c.inicio) : ""}
                  {c.fim ? ` → ${fmtDt(c.fim)}` : ""}
                </span>
                <button
                  onClick={() =>
                    setF((p) => ({
                      ...p,
                      check: p.check.filter((x) => x.i !== c.i),
                    }))
                  }
                  className="compAcaoModal__taskRemoveBtn"
                >
                  <Trash2 size={11} />
                </button>
              </div>
            ))}
            <div className="compAcaoModal__addTaskRow">
              <input
                placeholder="Nova tarefa..."
                value={newTask.t}
                onChange={(e) =>
                  setNewTask((p) => ({ ...p, t: e.target.value }))
                }
                onKeyDown={(e) => e.key === "Enter" && addTask()}
                className="compAcaoModal__input compAcaoModal__input--sm"
              />
              <input
                type="date"
                value={newTask.inicio}
                onChange={(e) =>
                  setNewTask((p) => ({ ...p, inicio: e.target.value }))
                }
                className="compAcaoModal__input compAcaoModal__input--xs"
                title="Início"
              />
              <input
                type="date"
                value={newTask.fim}
                onChange={(e) =>
                  setNewTask((p) => ({ ...p, fim: e.target.value }))
                }
                className="compAcaoModal__input compAcaoModal__input--xs"
                title="Fim"
              />
              <button
                onClick={addTask}
                className="compAcaoModal__addTaskBtn"
              >
                <Plus size={13} />
              </button>
            </div>
          </div>
          {/* Drivers afetados — desabilitado temporariamente */}
          {/*
          <div>
            {lbl("Drivers afetados por este plano")}
            <div className="compAcaoModal__driversHint">
              Selecione quais drivers você espera impactar ao executar este
              plano. Isso ajuda a Eva a correlacionar sucessos e sugerir planos
              semelhantes.
            </div>
            <div className="compAcaoModal__driverChips">
              {[].map((drv) => {
                const checked = (f.drivers || []).includes(drv.slug);
                return (
                  <div
                    key={drv.slug}
                    onClick={() => {
                      const curr = f.drivers || [];
                      const next = checked
                        ? curr.filter((x) => x !== drv.slug)
                        : [...curr, drv.slug];
                      setF((p) => ({ ...p, drivers: next }));
                    }}
                    title={drv.desc}
                    className={`compAcaoModal__driverChip${checked ? " is-active" : ""}`}
                  >
                    <span className="compAcaoModal__driverIcon">
                      {drv.icon}
                    </span>
                    <span>{drv.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
          */}
          {/* Links do plano de ação (Drive, Dropbox, docs externos) */}
          <div>
            {lbl("Links e arquivos (Drive, Dropbox, etc)")}
            {(f.links || []).map((l) => (
              <div
                key={l.id}
                className="compAcaoModal__linkItem"
              >
                <LinkIcon size={12} color={C.blue} style={{ flexShrink: 0 }} />
                <div className="compAcaoModal__linkBody">
                  <div className="compAcaoModal__linkLabel">{l.label}</div>
                  <div className="compAcaoModal__linkUrl">{l.url}</div>
                </div>
                <button
                  onClick={() => removeLink(l.id)}
                  className="compAcaoModal__linkRemoveBtn"
                >
                  <Trash2 size={11} />
                </button>
              </div>
            ))}
            <div className="compAcaoModal__addLinkRow">
              <input
                placeholder="Nome (opcional)"
                value={newLink.label}
                onChange={(e) =>
                  setNewLink((p) => ({ ...p, label: e.target.value }))
                }
                className="compAcaoModal__input compAcaoModal__input--sm"
              />
              <input
                placeholder="https://drive.google.com/..."
                value={newLink.url}
                onChange={(e) =>
                  setNewLink((p) => ({ ...p, url: e.target.value }))
                }
                onKeyDown={(e) => e.key === "Enter" && addLink()}
                className="compAcaoModal__input compAcaoModal__input--sm"
              />
              <button
                onClick={addLink}
                className="compAcaoModal__addLinkBtn"
              >
                <Plus size={13} />
              </button>
            </div>
          </div>
        </div>
        <div className="compAcaoModal__footer">
          <button
            onClick={onClose}
            className="compAcaoModal__cancelBtn"
          >
            Cancelar
          </button>
          <button
            onClick={() => {
              if (valid) {
                const today = todayStr();
                const agora = new Date().toTimeString().slice(0, 5);
                const user = "Renato"; // em produção viria do auth context
                const isNew = !acao;
                let histEntry;
                if (isNew) {
                  histEntry = {
                    dt: today,
                    hora: agora,
                    user,
                    tx: "Plano de ação criado",
                  };
                } else {
                  const changes = [];
                  if (acao.titulo !== f.titulo) changes.push("título");
                  if (acao.desc !== f.desc) changes.push("descrição");
                  if (String(acao.v_meta) !== String(f.v_meta))
                    changes.push(`meta → ${f.v_meta}`);
                  if (acao.prazo !== f.prazo)
                    changes.push(`prazo → ${fmtDt(f.prazo)}`);
                  if (acao.resp !== f.resp)
                    changes.push(`responsável → ${f.resp}`);
                  if (acao.prio !== f.prio)
                    changes.push(`prioridade → ${f.prio}`);
                  if (acao.status !== f.status)
                    changes.push(`status → ${f.status}`);
                  if ((acao.check || []).length !== (f.check || []).length)
                    changes.push(`tarefas (${(f.check || []).length})`);
                  if ((acao.drivers || []).length !== (f.drivers || []).length)
                    changes.push(`drivers (${(f.drivers || []).length})`);
                  if ((acao.links || []).length !== (f.links || []).length)
                    changes.push(`links (${(f.links || []).length})`);
                  const tx = changes.length
                    ? `Editou: ${changes.join(", ")}`
                    : "Plano atualizado";
                  histEntry = { dt: today, hora: agora, user, tx };
                }
                const histAtual = f.hist && f.hist.length ? f.hist : [];
                onSave({
                  ...f,
                  id: f.id || today,
                  v_atual: Number(f.v_atual) || 0,
                  v_baseline: Number(f.v_baseline) || Number(f.v_atual) || 0,
                  v_meta: Number(f.v_meta),
                  hist: [...histAtual, histEntry],
                  med: f.med.length >= 2
                    ? f.med
                    : [
                        { p: "Início", v: Number(f.v_baseline) || Number(f.v_atual) || 0 },
                        { p: "Atual", v: Number(f.v_atual) || 0 },
                      ],
                  links: f.links || [],
                  drivers: f.drivers || [],
                });
                onClose();
              }
            }}
            disabled={!valid}
            className={`compAcaoModal__saveBtn${!valid ? " is-disabled" : ""}`}
          >
            {acao ? "Salvar" : "Criar ação"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AcaoModal;
